import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import _camelCase from 'lodash/camelCase';
import _isArray from 'lodash/isArray';
import _map from 'lodash/map';
import { EditorBlock } from 'draft-js';
import { Map } from 'immutable';
import { TABLE_STRUCTURE_ELEMENTS } from './Table.constants';
import PropertyControlledComponent from '../../../PropertyControlledComponent';
import { blockStyleFn } from '../../helpers/rickTextEditor.helpers';
var Table = function Table(props) {
  var _block$getData, _block$getData2;
  var block = props.block,
    editorContainerRef = props.blockProps.editorContainerRef;
  // if this is not the first table block, then we target the <td> element in the applicable position
  // to render the current block into.
  if ((_block$getData = block.getData()) !== null && _block$getData !== void 0 && _block$getData.get(TABLE_STRUCTURE_ELEMENTS.TABLE_POSITION) && !((_block$getData2 = block.getData()) !== null && _block$getData2 !== void 0 && _block$getData2.get(TABLE_STRUCTURE_ELEMENTS.TABLE_SHAPE))) {
    var _block$getData3;
    var position = (_block$getData3 = block.getData()) === null || _block$getData3 === void 0 ? void 0 : _block$getData3.get(TABLE_STRUCTURE_ELEMENTS.TABLE_POSITION);
    var target = editorContainerRef === null || editorContainerRef === void 0 ? void 0 : editorContainerRef.querySelector("[data-position='".concat(position, "']"));
    if (target) {
      return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(EditorBlock, _extends({
        blockStyleFn: blockStyleFn
      }, props)), target);
    }
    return null;
  }
  // If we get here we know we are rendering the first block of the table and will render the whole DOM structure of the table
  var data = block.getData();
  var tableKey = data.get(TABLE_STRUCTURE_ELEMENTS.TABLE_KEY);
  var tableStyle = Map(data.get(TABLE_STRUCTURE_ELEMENTS.TABLE_STYLE)).mapKeys(function (style) {
    return _camelCase(style);
  }).toJS();
  var tableShape = data.get(TABLE_STRUCTURE_ELEMENTS.TABLE_SHAPE);
  if (!_isArray(tableShape)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("table", {
    key: tableKey,
    style: tableStyle,
    id: tableKey
  }, /*#__PURE__*/React.createElement("tbody", null, _map(tableShape, function (row, rowIndex) {
    var _data$get, _data$get2;
    var cStyle = ((_data$get = data.get('rowStyle')) === null || _data$get === void 0 ? void 0 : _data$get[rowIndex]) && Map((_data$get2 = data.get('rowStyle')) === null || _data$get2 === void 0 ? void 0 : _data$get2[rowIndex]).mapKeys(function (style) {
      return _camelCase(style);
    }).toJS();
    return /*#__PURE__*/React.createElement("tr", {
      key: rowIndex,
      style: cStyle
    }, _map(row, function (cell, columnIndex) {
      var cellStyle = Map(cell.style).mapKeys(function (style) {
        return _camelCase(style);
      }).toJS();
      if (cell.element === 'th') {
        return /*#__PURE__*/React.createElement("th", {
          key: columnIndex,
          style: cellStyle,
          colSpan: cell.colspan,
          rowSpan: cell.rowspan,
          "data-position": "".concat(tableKey, "-").concat(rowIndex, "-").concat(columnIndex)
        }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
          controllerProperty: rowIndex === 0 && columnIndex === 0
        }, /*#__PURE__*/React.createElement(EditorBlock, _extends({
          blockStyleFn: blockStyleFn
        }, props))));
      }
      return /*#__PURE__*/React.createElement("td", {
        key: columnIndex,
        style: cellStyle,
        colSpan: cell.colspan,
        rowSpan: cell.rowspan,
        "data-position": "".concat(tableKey, "-").concat(rowIndex, "-").concat(columnIndex)
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: rowIndex === 0 && columnIndex === 0
      }, /*#__PURE__*/React.createElement(EditorBlock, _extends({
        blockStyleFn: blockStyleFn
      }, props))));
    }));
  })));
};
Table.propTypes = {
  block: PropTypes.instanceOf(EditorBlock).isRequired,
  blockProps: PropTypes.object.isRequired
};
export default Table;